import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Logevent, LogeventCreate } from './logevent';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
@Injectable({ providedIn: 'root' })

export class LogEventService {
    private logUrl = environment.appURL + '/logevents';
    constructor(private http: HttpClient) { }

    // RECORD EVENT LOG FOR USER ACTIONS 
    logEvent(user: number, action: string, details: any) {

        const event = new LogeventCreate
        event.details = details;
        event.action = action;
        event.timestamp = new Date;
        event.user = user;

        // Send the event to the server for persistent storage
        this.http.post(this.logUrl, event, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) }).subscribe();
    }

    // RECORD EVENT LOG FOR DISPATCH ORDER
    logEventDo(user: number, action: string, details: any, dispatchorder: number, ticket: number) {
        const event = new LogeventCreate
        event.details = details;
        event.action = action;
        event.timestamp = new Date;
        event.user = user;
        event.dispatchorder = dispatchorder;
        event.ticket = ticket;
        // Send the event to the server for persistent storage
        this.http.post(this.logUrl, event, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) }).subscribe();
    }

    // GET ALL EVENTS LOG
    getLogEvents() {
        return this.http.get<Logevent[]>(this.logUrl, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) }).pipe(tap(_ => { }));
    }
  
    //  GET LOG ORDER BY DISPATCH ORDER GRAPHQL
    getLogByDispatchOrder(doId: number) {
        var query = "{logevents (where:{ dispatchorder:" + doId + "}){ id action details timestamp user{id username firstname lastname}  dispatchorder{id details}}}";
        const url = environment.graphURL + query;
        return this.http.get<Logevent[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['logevents']));
    }

    //  GET LOG ORDER BY TICKET ID GRAPHQL
    getLogByTicket(tId: number) {
        var query = "{logevents (where:{ ticket:" + tId + "}){ id action details timestamp user{id username firstname lastname}  dispatchorder{id details}}}";
        const url = environment.graphURL + query;
        return this.http.get<Logevent[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['logevents']));
    }

    // DELET LOGEVENT
    deleteLogevent(id: number): Observable<any> {
        console.log("We are deleteing");
        const urld = this.logUrl + "/" + id;
        return this.http.delete<Logevent>(urld, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', [])));
    }

    //  ERROR HANDLING
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            console.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }


}